<script setup lang="ts">

</script>
<template>
  <div class="footer">
    <div class="social-icons">
      <div class="icon">
        <a href="https://www.instagram.com/mody_veranstaltungstechnik/" target="_blank"
           aria-label="Go to our Instagram account."><i class="pi pi-instagram"/></a>
      </div>
      <div class="icon">
        <a href="https://www.facebook.com/mody.at/" target="_blank"
           aria-label="Go to our Facebook account."><i class="pi pi-facebook"/></a>
      </div>
      <div class="icon">
        <a href="https://www.linkedin.com/company/mody-veranstaltungstechnik/about/" target="_blank"
           aria-label="Go to our LinkedIn account."><i class="pi pi-linkedin"/></a>
      </div>
    </div>
    <div class="footer-links">
      <NuxtLink to="/impressum">Impressum</NuxtLink>
      <NuxtLink to="/privacy">Datenschutz</NuxtLink>
      <NuxtLink to="/contact">Kontakt</NuxtLink>
      <NuxtLink to="/agb">AGBs</NuxtLink>
      <NuxtLink to="/account">Konto</NuxtLink>
    </div>
    <div class="copyright">
      © Stefan Schäfer {{new Date().getFullYear()}}
    </div>
  </div>
</template>
<style scoped lang="scss">
.footer{
  width:100%;
  background:rgb(9,35,45);
  padding-bottom: 20px;
}
.social-icons{
  width:100%;
  display:flex;
  justify-content: space-around;
  padding:20px;
  max-width: 300px;
  margin:auto;
  .icon{
    border:1px solid white;
    border-radius: 50%;
    padding:10px;
    a{
      color:unset;
      display:block;
      width: 20px;
      height:20px;
      .pi{
        font-size: 20px;
      }
    }
  }
}
.footer-links{
  max-width: 300px;
  margin:auto;
  display:flex;
  justify-content: center;
  flex-wrap: wrap;
  text-align: left;
  a{
    color:unset;
    padding: 5px 10px;
  }
}
.copyright{
  text-align:center;
  font-size:12px;
  margin-top:20px;
}
</style>